import { useEffect } from 'react'
import useAuth from 'hooks/useAuth'
import { ChatMsgPusher } from '../pusher'
import { TGetChatMessage } from '../types'
import { recievedAudio } from './useChatAlertSound'
import { addChatMessageToCache } from '../functions'

type TNewMessage = {
 data: TGetChatMessage
 sender_id: number
}

const useChatMessagePusher = ({
 leadId,
 chatId,
}: {
 leadId?: number
 chatId?: number
}) => {
 const { user } = useAuth()
 useEffect(() => {
  if (!chatId) return
  const channelName = `chat.${chatId}`
  const channel = ChatMsgPusher.subscribe(channelName)
  channel.bind('new-message', async (data: TNewMessage) => {
   if (data?.data) {
    if (Number(user?.id) !== data.sender_id) {
     addChatMessageToCache(leadId, data.data)
     recievedAudio?.play()
    } else {
     addChatMessageToCache(leadId, data.data)
    }
   }
  })
  return () => {
   ChatMsgPusher.unsubscribe(channelName)
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [leadId, user?.id])

 return {}
}

export default useChatMessagePusher
